import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["theme", "clearable", "onClose", "onChange", "placeholder", "inputProps", "classes", "value", "size", "locale", "translations"],
    _excluded2 = ["onBlur", "onFocus", "ref"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { useCombinedRefs, useDictionary } from "../hooks";
import { CloseSmallLinear, Search as SearchIcon } from "../icons";
import { ButtonBase } from "../internal/ButtonBase";
import { InputBase } from "../internal/InputBase";
import noop from "../utils/noop";
import { themes, TRANSLATIONS } from './constants';
import styles from './Search.css';
var cx = classNames.bind(styles);
var Search = /*#__PURE__*/forwardRef(function Search(_ref, ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'free' : _ref$theme,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? true : _ref$clearable,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      placeholder = _ref.placeholder,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? defaultPropObject : _ref$inputProps,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      value = _ref.value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'ru' : _ref$locale,
      _ref$translations = _ref.translations,
      translations = _ref$translations === void 0 ? defaultPropObject : _ref$translations,
      props = _objectWithoutProperties(_ref, _excluded);

  var onBlur = inputProps.onBlur,
      onFocus = inputProps.onFocus,
      inputPropsRef = inputProps.ref,
      inputRest = _objectWithoutProperties(inputProps, _excluded2);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var combinedInputRef = useCombinedRefs(inputRef, inputPropsRef);
  var combinedRootRef = useCombinedRefs(rootRef, ref);
  var dictionary = useDictionary({
    translations: _objectSpread(_objectSpread({}, TRANSLATIONS), translations),
    locale: locale
  });

  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    onChange(target.value);
  };

  var handleClear = function handleClear() {
    var _inputRef$current;

    onChange('');
    onClose();
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };

  var handleFocus = function handleFocus(e) {
    setFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  };

  var handleBlur = function handleBlur(e) {
    var _rootRef$current;

    if ((_rootRef$current = rootRef.current) !== null && _rootRef$current !== void 0 && _rootRef$current.contains(e.relatedTarget)) {
      return;
    }

    setFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('root', "theme_".concat(theme), "size_".concat(size), {
      focused: theme === themes.free ? focused || value : focused
    }, classes.root),
    ref: combinedRootRef
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('search_icon', classes.searchIcon)
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), /*#__PURE__*/React.createElement(InputBase, _extends({}, inputRest, {
    value: value,
    placeholder: placeholder || dictionary.t('search'),
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: combinedInputRef,
    onChange: handleChange,
    className: classes.input
  })), clearable && value && /*#__PURE__*/React.createElement(ButtonBase, {
    className: cx('close_button', classes.closeButton),
    onClick: handleClear
  }, /*#__PURE__*/React.createElement(CloseSmallLinear, null)));
});
export default Search;